module.exports = __webpack_public_path__ + "72e853cb2d61f65993b89f0429f9417d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/confirm-turn-off/confirm-turn-off-sms-service.html
// module id = 1612
// module chunks = 0